"use strict";
/*
 * Created on 8. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");

var RegularProductPrice_1 = require("../../product/model/RegularProductPrice");

var RegularProductPriceConverter_1 = require("./RegularProductPriceConverter");
/**
 * @author Radek Beran
 */


var RegularProductPriceConverterImpl =
/*#__PURE__*/
function (_RegularProductPriceC) {
  _inherits(RegularProductPriceConverterImpl, _RegularProductPriceC);

  function RegularProductPriceConverterImpl() {
    _classCallCheck(this, RegularProductPriceConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(RegularProductPriceConverterImpl).apply(this, arguments));
  }

  _createClass(RegularProductPriceConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new RegularProductPrice_1.RegularProductPrice(!utils_1.Utils.isValueMissing(source.value) ? conversions.toBigNumber(source.value) : null, !utils_1.Utils.isValueMissing(source.valueRounded) ? conversions.toBigNumber(source.valueRounded) : null, !utils_1.Utils.isValueMissing(source.vatRate) ? conversions.toBigNumber(source.vatRate) : null);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var result = {};
      Object.assign(result, {
        value: source.value !== null ? conversions.fromBigNumber(source.value) : null,
        valueRounded: source.valueRounded !== null ? conversions.fromBigNumber(source.valueRounded) : null,
        vatRate: source.vatRate !== null ? conversions.fromBigNumber(source.vatRate) : null
      });
      return result;
    }
  }]);

  return RegularProductPriceConverterImpl;
}(RegularProductPriceConverter_1.RegularProductPriceConverter);

exports.RegularProductPriceConverterImpl = RegularProductPriceConverterImpl;